// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"433":"5658af34","895":"059fc0f8"}[chunkId] + ".css";
};